"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme, props, state) {
  var palette = theme.palette;
  var appearance = theme.appearance;

  if (state.hover) {
    appearance = theme.appearanceHover;
  }

  if (props.disabled) {
    appearance = theme.appearanceDisabled;
  }

  return {
    root: {
      display: theme.display,
      width: theme.width,
      minWidth: theme.minWidth
    },
    wrapper: {
      position: 'relative'
    },
    calendar: {
      display: 'block',
      position: 'absolute',
      bottom: palette.gutter + 'px',
      right: 0,
      width: '24px',
      height: '24px',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'background-image',
      backgroundImage: appearance,
      backgroundSize: 'contain',
      cursor: props.disabled ? 'default' : 'pointer'
    },
    picker: {
      position: 'absolute',
      zIndex: theme.zIndex,
      transformOrigin: 'left top'
    }
  };
}